import IBasicResponse from "@/interfaces/Data/IBasicResponse";
import { ILoginParameter, ILoginResponse } from "@/interfaces/Data/Login";
import baseApi from "@/redux/features/baseApi";

const apiWithTag = baseApi.enhanceEndpoints({ addTagTypes: ["Service"] });

export const serviceApi = apiWithTag.injectEndpoints({
  endpoints: (build) => ({
    projectUserLogin: build.mutation<ILoginResponse, ILoginParameter>({
      query: (
        data
      ) => {
        return {
          url: `/user/web/login`,
          method: "POST",
          body: data
        };
      },
      transformResponse: (response: IBasicResponse<ILoginResponse> & ILoginResponse) => {
        return response;
      },
    }),
    unRegisterProjectUser: build.mutation<void, {
      project: string
    }>({
      query: (
        data
      ) => {
        return {
          url: `/user`,
          method: "DELETE",
        };
      },
    }),

    recoverProjectUser: build.mutation<void, {
      project: string
    }>({
      query: (
        data
      ) => {
        return {
          url: `/user/recover`,
          method: "POST",
        };
      },
    }),
  }),
});

export const { useProjectUserLoginMutation, useUnRegisterProjectUserMutation, useRecoverProjectUserMutation } = serviceApi;
